import { createSlice } from '@reduxjs/toolkit';
import { ActionStatus } from '../../../../common/constants/action-status';
import { defaultApiState } from '../../../../common/constants/api-constants';
import { MyDigitalProductsAggregatedState } from '../interface/my-digital-products-aggregated.interface';
import { fetchMyDigitalProductsAggregated } from '../thunks/fetch-my-digital-products-aggregated.thunk';

export const myDigitalProductsAggregatedInitialState: MyDigitalProductsAggregatedState = defaultApiState;

export const myDigitalProductsAggregatedSlice = createSlice({
  name: 'myDigitalProductsAggregated',
  initialState: myDigitalProductsAggregatedInitialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchMyDigitalProductsAggregated.pending, (state) => {
        state.status = ActionStatus.loading;
      })
      .addCase(fetchMyDigitalProductsAggregated.fulfilled, (state, action) => {
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(fetchMyDigitalProductsAggregated.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      });
  },
});

export const myDigitalProductsAggregatedReducer = myDigitalProductsAggregatedSlice.reducer;
